// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__yuXZL","container":"LayoutSideNavigation_container__1ybsk","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__3Xysl"};